/** Tus menciones: dónde te han nombrado, con un trozo del comentario, y marcar como leído. */
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ErrorDeApi, api } from '../api'
import { Cargando, Error, Vacio } from '../componentes/piezas'
import { usePortal } from '../contexto'
import { hace } from '../textos'
import type { Mencion } from '../tipos'

/** La barra lateral escucha esto para actualizar el número de pendientes. */
export const EVENTO_MENCIONES = 'portal:menciones'

export default function Menciones() {
  const { ruta, servidor } = usePortal()
  const navegar = useNavigate()
  const [lista, setLista] = useState<Mencion[] | null>(null)
  const [error, setError] = useState('')

  const cargar = useCallback(async () => {
    try {
      setLista(await api.get<Mencion[]>(`${ruta}/menciones`))
      setError('')
    } catch (e) {
      setError(e instanceof ErrorDeApi ? e.message : 'No se han podido cargar las menciones.')
    }
  }, [ruta])

  useEffect(() => {
    void cargar()
  }, [cargar])

  async function marcar(ids: number[] | null) {
    await api.post(`${ruta}/menciones/leer`, ids === null ? {} : { ids })
    window.dispatchEvent(new Event(EVENTO_MENCIONES))
    await cargar()
  }

  async function abrir(m: Mencion) {
    if (!m.leida) await marcar([m.id]).catch(() => undefined)
    navegar(m.tipo === 'request'
      ? `/${servidor.id}/solicitudes/${m.numero}`
      : `/${servidor.id}/paginas/${m.pagina_id}`)
  }

  const sinLeer = lista?.filter((m) => !m.leida).length ?? 0
  return (
    <>
      <header className="cabecera">
        <h1>Menciones</h1>
        <div className="cabecera__acciones">
          <button className="boton" disabled={sinLeer === 0} onClick={() => void marcar(null)}>
            Marcar todas como leídas
          </button>
        </div>
      </header>
      <div className="contenido">
        {error && <Error>{error}</Error>}
        {!lista && !error && <Cargando filas={3} />}
        {lista?.length === 0 && (
          <Vacio titulo="Nadie te ha mencionado todavía">
            <p>Cuando alguien escriba tu nombre con @ en un comentario, saldrá aquí.</p>
          </Vacio>
        )}
        {lista && lista.length > 0 && (
          <ul className="lista tarjeta">
            {lista.map((m) => (
              <li key={m.id}>
                <button className={`fila mencion-fila${m.leida ? '' : ' mencion-fila--nueva'}`}
                        onClick={() => void abrir(m)}>
                  <span className="yo__avatar" aria-hidden="true">
                    {(m.por?.nombre ?? '?').trim().charAt(0).toUpperCase()}
                  </span>
                  <span className="fila__principal">
                    <span className="fila__titulo">
                      {m.por?.nombre ?? 'Alguien'} te ha mencionado en {m.titulo}
                      {m.interna && <span className="etiqueta" style={{ marginLeft: 8 }}>Interno</span>}
                    </span>
                    <span className="fila__meta">{m.fragmento}</span>
                  </span>
                  <span className="fila__meta">{hace(m.cuando)}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  )
}
